<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <h1 class="page-header">Update Document</h1>
        <div class="inner_patient_report">
            <form class="forms-sample" enctype="multipart/form-data" method="post" @submit.stop.prevent="updateDocument"
                autocomplete="off">
                <div class="row mt-5">
                    <div class="col-md-12 d-flex align-items-stretch grid-margin">
                        <div class="row flex-grow">
                            <div class="col-12 grid-margin">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <b-form-group label="Name" label-for="Name">
                                                    <b-form-input type="text" id="Name" v-model="documentData.DocName"
                                                        name="DocName" autocomplete="Name"
                                                        :state="$v.documentData.DocName.$dirty ? !$v.documentData.DocName.$error : null"
                                                        placeholder="Name">
                                                    </b-form-input>
                                                    <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                        required
                                                        field.
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                                <b-form-group label="Module" label-for="Module">
                                                    <b-form-select @change="getWeeksByModule" name="Module"
                                                        v-model="documentData.DocModule" :options="allModules"
                                                        :state="$v.documentData.DocModule.$dirty ? !$v.documentData.DocModule.$error : null"
                                                        id="Module" class="mb-3" value-field="ModuleID"
                                                        text-field="ModuleName">
                                                    </b-form-select>

                                                    <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                        required
                                                        field.
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                                <div role="group" class="form-group">
                                                    <label for="Week" class="d-block">Week</label>
                                                    <div>
                                                        <select v-model="documentData.WeekNumber" class="custom-select"
                                                            id="Week" required name="Week">
                                                            <option v-for="(week, index) in allWeeks"
                                                                :value="week.WeekNumber" :key="index">{{ week.WeekName
                                                                }} week - {{ week.WeekNumber
                                                                }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <b-form-group label="Starting Date" label-for="date">
                                                    <b-form-input type="date" id="date" v-model="sdate" name="Name"
                                                        autocomplete="date" placeholder="date">
                                                    </b-form-input>
                                                    <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                        required
                                                        field.
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                                <b-form-group label="Ending Date" label-for="edate">
                                                    <b-form-input type="date" id="edate" v-model="edate" name="Name"
                                                        autocomplete="date" placeholder="date">
                                                    </b-form-input>
                                                    <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                        required
                                                        field.
                                                    </b-form-invalid-feedback>
                                                </b-form-group>

                                                <b-form-group label="Document order" label-for="order">
                                                    <b-form-input type="number" id="order"
                                                        :state="$v.documentData.DocOrder.$dirty ? !$v.documentData.DocOrder.$error : null"
                                                        v-model="documentData.DocOrder" name="DocOrder"
                                                        autocomplete="order" placeholder="order">

                                                    </b-form-input>
                                                    <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                        required
                                                        field.
                                                    </b-form-invalid-feedback>
                                                </b-form-group>

                                                <b-form-group label-for="file" class="input-group custom-file-button">
                                                    <label class="input-group-text" for="file">Upload</label>
                                                    <input class="form-control" type="file" id="file" @change="pdfSave"
                                                        name="uploadDocument" accept="application/pdf" />
                                                </b-form-group>
                                                <div>
                                                    <a class="btn btn-secondary" :href="pdfUrl" target="_blank">
                                                        View Document
                                                    </a>
                                                </div>
                                                <!-- <div>
                                                    <a class="btn btn-secondary"
                                                        :href="`${this.$server_url}storage/documents/${documentData.DocLocation}`"
                                                        target="_blank">view document</a>
                                                </div> -->
                                            </div>
                                            <div class="col-md-6">
                                                <b-form-group label="Description:" label-for="Description">
                                                    <b-form-textarea id="Description"
                                                        v-model="documentData.DocDescription"
                                                        :state="$v.documentData.DocDescription.$dirty ? !$v.documentData.DocDescription.$error : null"
                                                        placeholder="Enter something..." rows="3" max-rows="3">
                                                    </b-form-textarea>
                                                    <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                        required
                                                        field.
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="checkboxes row">
                                                        <div class="checkbox-field col-md-6 ">
                                                            <th><input id="Webinar" :checked="documentData.Webinar == 1"
                                                                    @input="updateStatus('Webinar', $event.target.checked)"
                                                                    name="Webinar" type="checkbox"> <label
                                                                    for="Webinar">Webinar 1</label>
                                                            </th>
                                                        </div>
                                                        <div class="checkbox-field col-md-6 ">
                                                            <th><input id="ScottNotes"
                                                                    :checked="documentData.ScottNotes == 1"
                                                                    @input="updateStatus('ScottNotes', $event.target.checked)"
                                                                    type="checkbox"><label for="ScottNotes">Scott
                                                                    Notes</label>
                                                            </th>
                                                        </div>
                                                        <div class="checkbox-field col-md-6 ">
                                                            <th><input id="Active" :checked="documentData.Active == 1"
                                                                    @input="updateStatus('Active', $event.target.checked)"
                                                                    type="checkbox"><label for="Active">Active</label>
                                                            </th>
                                                        </div>
                                                        <div class="checkbox-field col-md-6 ">
                                                            <th><input id="Archive" :checked="documentData.Archive == 1"
                                                                    @input="updateStatus('Archive', $event.target.checked)"
                                                                    type="checkbox"><label for="Archive">Archive</label>
                                                            </th>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <h5 class="text-danger">Skill Sets:</h5>
                                                    <div class="checkboxes row">
                                                        <div class="checkbox-field col-md-6 "
                                                            v-for="(skill, index) in skills" :key="index">
                                                            <th> <input :id="'s' + skill.SkillSetID"
                                                                    @input="updateSkillSetId(skill.SkillSetID, $event.target.checked)"
                                                                    :checked="documentData[`SkillSetID${skill.SkillSetID}`] == 1"
                                                                    type="checkbox">
                                                                <label :for="`s${skill.SkillSetID}`">{{
                                                                    skill.SkillSetName
                                                                }} </label>
                                                            </th>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                            </div>
                                        </div>
                                        <div style="margin-top: 2%">
                                            <div v-for="(item, index) in currentWeeks" :key="item.DocID" class="row">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label class="my_lbl inline">{{ index + 1 }}.{{ item.DocName
                                                            }}</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <input class="inline form-control" type="number"
                                                        :name="'doc' + item.DocID" v-model="item.DocOrder">
                                                </div>
                                                <div class="col-md-6 mt-3">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6"></div>
                                            <div class="col-md-6 mt-3">
                                                <b-button type="submit" variant="success"
                                                    class="btn float-right btn-success">
                                                    Submit
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from 'moment'
export default {
    name: "add_document_form",
    mixins: [validationMixin],
    data() {
        return {
            sdate: '',
            edate: '',
            currdoc: '',
            allModules: [
                {
                    ModuleID: "",
                    ModuleName: "Select a module"
                }
            ],
            allWeeks: [
                {
                    WeekID: "",
                    WeekName: "Select a",
                    WeekNumber: ""
                }
            ],
            currentWeeks:
            {
                DocID: "",
                WeekName: "",
                DocOrder: ""
            },
            documentData: {
                DocName: "",
                DocModule: '',
                WeekID: "",
                WeekNumber: "",
                StartingDate: "",
                EndingDate: "",
                DocOrder: "",
                DocDescription: "",
                DocPDF: null,
                Webinar: 0,
                ScottNotes: 0,
                Active: 0,
                Archive: 0
            },
            skills: {},
            skillSetIds: {},
            pdfUrl: null
        }
    },
    validations: {
        documentData: {
            DocName: {
                required
            },
            DocModule: {
                required
            },
            DocDescription: {
                required
            },
            DocOrder: {
                required
            }
        }
    },
    methods: {
        editDoc() {
            if (this.$route.params.document) {
                this.documentData = this.$route.params.document;
                let date = this.documentData;
                this.documentData.StartingDate = moment(date.StartingDate).format('Y-MM-DD')
                this.documentData.EndingDate = moment(date.EndingDate).format('Y-MM-DD')
            } else {
                this.$router.push({ name: "view_document" })
            }
        },
        getCurrentWeekDoc() {
            API.currentWeekDoc(
                { moduleID: this.documentData.DocModule, WeekID: this.documentData.WeekID },
                data => {
                    this.currentWeeks = data.data.data;
                    this.currentWeeks.sort((a, b) => parseInt(a.DocOrder) - parseInt(b.DocOrder));
                }, err => {

                })
        },
        updateSkillSetId(skillId, checked) {
            this.$set(this.skillSetIds, 'SkillSetID' + skillId, checked ? 1 : 0);
        },
        updateStatus(field, checked) {
            this.documentData[field] = checked ? 1 : 0;
        },
        // pdfSave(e) {
        //     this.documentData.DocPDF = e.target.files[0]
        // },
        pdfSave(e) {
            // Get the selected file from the input
            const file = e.target.files[0];

            // Check if the selected file is a PDF
            if (file && file.type === 'application/pdf') {
                // Store the selected file in documentData
                this.documentData.DocPDF = file;

                // Generate a temporary URL for the PDF file
                this.pdfUrl = URL.createObjectURL(file);
            } else {
                // If the file is not a PDF, clear the URL and reset the file
                this.documentData.DocPDF = null;
                this.pdfUrl = null;
            }
        },
        getDocumentdetails() {
            API.getDocumentdetails({ moduleID: this.documentData.DocModule, DocID: this.documentData.DocID }, this.getDocumentdetailscb, this.errorCB)

        },
        getDocumentdetailscb(res) {
            this.currdoc = res.data;
            this.sdate = moment(this.currdoc.StartingDate).format('Y-MM-DD');
            this.edate = moment(this.currdoc.EndingDate).format('Y-MM-DD')
        },
        getWeeksByModule() {
            API.getWeeksByModule({ moduleID: this.documentData.DocModule }, this.getWeeksByModuleCB, this.errorCB)
        },
        getWeeksByModuleCB(res) {
            this.allWeeks = [
                {
                    WeekID: "",
                    WeekName: "Select a",
                    WeekNumber: ""
                }
            ];
            res.data.forEach(element => {
                this.allWeeks.push(element)
            });
        },
        getAllModules() {
            API.getAllModules(this.getAllModulesCB, this.errorCB);
        },
        getAllModulesCB(res) {
            res.data.forEach(element => {
                this.allModules.push(element)
            });
        },
        updateDocument() {
            this.$v.documentData.$touch();
            if (this.$v.documentData.$anyError) {
                return;
            }
            const updatedWeeks = this.currentWeeks.map(item => ({
                DocID: item.DocID,
                DocOrder: parseInt(item.DocOrder)
            }));
            API.updateDocument({ ...this.documentData, ...this.skillSetIds, sdate: this.sdate, edate: this.edate }, this.updateDocumentCB, this.errorCB);
            API.updateCurrentWeeks(updatedWeeks)
                .then(response => {
                    this.getCurrentWeekDoc();
                    // Handle success response
                    this.$router.push({ name: "view_document" });
                })
                .catch(error => {
                    // Handle error response
                    console.error('Failed to update document:', error);
                });
        },
        updateDocumentCB(res) {
            this.editDoc()
            this.getAllSkills();
            this.getAllModules();
            this.getWeeksByModule();
            this.getCurrentWeekDoc();
            this.getDocumentdetails();
            this.$showNotification(res, 'success')
        },
        getAllSkills() {
            API.getAllSkills(this.getAllSkillsCB, this.errorCB);
        },
        getAllSkillsCB(res) {
            this.skills = res.data;
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    },
    mounted() {
        this.editDoc()
        this.getAllSkills();
        this.getAllModules();
        this.getWeeksByModule();
        this.getCurrentWeekDoc();
        this.getDocumentdetails();
    },
    components: {}
}
</script>
<style>
.custom-file-button input[type=file] {
    margin-left: -2px !important;
}

.custom-file-button input[type=file]::-webkit-file-upload-button {
    display: none;
}

.custom-file-button input[type=file]::file-selector-button {
    display: none;
}

.input-group-text {
    padding: 5px 30px;
    margin-bottom: 0;
    color: #fff;
    background-color: #1e77c5;
    border: 1px solid #adadad;
    border-radius: 2px;
}

.custom-file-button:hover label {
    background-color: #2184dab3;
    cursor: pointer;
}

.custom-file-button>div {
    display: flex;
    width: 100%;
}
</style>